import React, { useState } from 'react'

import PropTypes from 'prop-types'

import { BaseModal } from '@lyrahealth-inc/ui-core-crossplatform/src/organisms/baseModal/BaseModal'

import styles from './lyraCode.module.scss'
import LyraCodeExplanationModalContent from './LyraCodeExplanationModalContent'

const LyraCodeProfileDisplay = ({ lyraCode }: any) => {
  const [isModalOpen, setModalOpen] = useState(false)
  return (
    <>
      <div className={styles['lyra-code']}>{lyraCode}</div>
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
      <a onClick={() => setModalOpen(true)}>What is this?</a>
      <BaseModal
        isOpen={isModalOpen}
        // @ts-expect-error TS(2741): Property 'closeModal' is missing in type '{}' but ... Remove this comment to see the full error message
        body={<LyraCodeExplanationModalContent />}
        closeModal={() => setModalOpen(false)}
      />
    </>
  )
}

LyraCodeExplanationModalContent.propTypes = {
  // @ts-expect-error TS(2322): Type '{ lyraCode: PropTypes.Requireable<string>; }... Remove this comment to see the full error message
  lyraCode: PropTypes.string,
}

export default LyraCodeProfileDisplay
